import { Component, OnInit, ViewEncapsulation, Output } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { FormControl } from '@angular/forms';
import { MatDatepicker } from '@angular/material';
import { EventEmitter } from '@angular/core';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-common-month-picker',
  templateUrl: './common-month-picker.component.html',
  styleUrls: ['./common-month-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,


  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})


export class CommonMonthPickerComponent implements OnInit {

  date = new FormControl(moment().date() >= 10 ? moment() : moment().subtract(1, 'months').endOf('month'));
  @Output() monthSelect = new EventEmitter();
  today = new Date();
  maxDate = new Date().getDate() >= 10 ? new Date()  : new Date(this.today.getFullYear(), this.today.getMonth(), 0);
  
  constructor() { }

  ngOnInit(): void {
  }

  chosenYearHandler(normalizedYear: Moment): void {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>): void {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.monthSelect.emit(this.date.value._d);
  }

}
